import { supabase } from "@/integrations/supabase/client";

/** Prefer the Edge Function JSON `{ error }` over the generic "non-2xx" message. */
async function messageFromFunctionsError(error: unknown, data: unknown): Promise<string | null> {
  if (data && typeof data === "object" && "error" in data && (data as { error?: unknown }).error) {
    return String((data as { error: unknown }).error);
  }

  const ctx = (error as { context?: Response })?.context;
  if (ctx && typeof ctx.json === "function") {
    try {
      const payload = await ctx.clone().json();
      if (payload && typeof payload === "object") {
        if ("error" in payload && (payload as { error?: unknown }).error) {
          return String((payload as { error: unknown }).error);
        }
        if ("message" in payload && (payload as { message?: unknown }).message) {
          return String((payload as { message: unknown }).message);
        }
      }
    } catch {
      /* ignore parse failures */
    }
  }

  return null;
}

export async function invokeFunction<T = unknown>(
  name: string,
  body: Record<string, unknown> = {},
): Promise<T> {
  const { data, error } = await supabase.functions.invoke(name, { body });

  if (error) {
    const detail = await messageFromFunctionsError(error, data);
    throw new Error(detail || error.message || `${name} failed`);
  }

  if (data && typeof data === "object" && "error" in data && (data as { error?: unknown }).error) {
    throw new Error(String((data as { error: unknown }).error));
  }

  return data as T;
}
